// extracted by mini-css-extract-plugin
export var closeButton = "_lg-1";
export var closeX = "_lg-3";
export var container = "_lg-0";
export var image = "_lg-2";